import { render, staticRenderFns } from "./team-player.vue?vue&type=template&id=4a2733a8&scoped=true&"
import script from "./team-player.vue?vue&type=script&lang=js&"
export * from "./team-player.vue?vue&type=script&lang=js&"
import style0 from "./team-player.vue?vue&type=style&index=0&id=4a2733a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2733a8",
  null
  
)

export default component.exports